<template>
   <section class="password-section">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4>{{ $t("form_forgot_password") }}</h4>
                    <p>{{ $t("form_forgot_password_text") }}</p>
                    <form @submit="requestPassword()">
                        <input v-model="this.principal" type="" name="" placeholder="{{ $t('form_email') }}">
                        <button>{{ $t('buttons.send') }}</button>
                    </form>
                    <div class="volver">
                        <a :href="route + 'login'">
                            <span>
                                <img src="assets/img/backspace.svg">
                                {{ $t("buttons.back_to_home") }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
import { route } from "../../enviroment.js"
export default {
	name: "ForgotPassword",
    i18n: {
        messages: {
            en: {
                form_email: "Email",
                form_forgot_password: "Forgot your password?",
                form_forgot_password_text: "Don't worry, we will send you an email with the steps to restore it.",
                success: "Your password has been restored"
            },
            es: {
                form_email: "Correo electrónico",
                form_forgot_password: "¿Olvidaste tu contraseña?",
                form_forgot_password_text: "No te preocupes, te enviaremos un correo con instrucciones para resetearla.",
                success: "Su contraseña ha sido reestablecida"
            }
        }
    },
	data() {
		return {
            route : route,
            principal : ''
		}
	},
    methods:{
        requestPassword(){
            axios.post(this.$woe_api_uri + '/request-reset-password', 
                {
                    "principal":this.principal
                }
            ).then(() => {
                alert(this.$t("success"))
                location.href= "" + route + "";
            })
            .catch(function () {
            });
        }
    }
}
</script>